<template>
  <form action="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <p class="modal-card-body-message" v-html="message"/>
      </section>
      <footer class="modal-card-foot" v-if="type == 'confirm'">
        <div class="button close" @click="$emit('close')">いいえ</div>
        <div class="button submit" @click="submit()">はい</div>
      </footer>
      <footer class="modal-card-foot" v-if="type != 'confirm'">
        <div class="button submit" @click="$emit('close')">閉じる</div>
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  name: 'MessageModal',
  props: {
    title: String,
    message: String,
    type: String
  },
  methods: {
    submit() {
      this.$emit('submit');
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss">
@import '../assets/scss/modal.scss';
</style>
